export const paragraphStyle = { marginTop: 20 };
